var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reports-survey',{attrs:{"template-id":"OpinionSurvey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }